import { Property } from "../../../../../library-js/events/Property";
import { WebAppContextSelection } from "../../../../../library-js/web-app/selection/WebAppContextSelection";
import { WebAppSelection } from "../../../../../library-js/web-app/selection/WebAppSelection";

export class AudioEditorSelection extends WebAppContextSelection
{
  playStart = new Property<number>( 0 );
  playEnd   = new Property<number>( 1 );
  looping   = new Property<boolean>( false );
  playing   = new Property<boolean>( false );
  
}